import { render, staticRenderFns } from "./MerchantApi.vue?vue&type=template&id=0b24b0c6&scoped=true"
import script from "./MerchantApi.vue?vue&type=script&lang=js"
export * from "./MerchantApi.vue?vue&type=script&lang=js"
import style0 from "./MerchantApi.vue?vue&type=style&index=0&id=0b24b0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24b0c6",
  null
  
)

export default component.exports